<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/crud/address-info"></ion-back-button>
    </ion-buttons>
    <ion-title>{{'CRUD_PROFILE_LIB.OWNER' | translate}}</ion-title>

    @if (form.valid) {
      <img
        style="margin-right: 10px;" alt="Point"
        src="assets/icon/whites/point.svg" width="25" slot="end"
        (click)="gotNextPage()"
        (keypress)="gotNextPage()" />
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  <br/>
  <div class="ion-text-center">
    <img src="assets/icon/colors/purple/reset-password.svg" alt="Reset" width="90" />
    <div class="ion-padding">
      <br/>
      <span style="color: var(--ion-color-tertiary)">{{'CRUD_PROFILE_LIB.MESSAGE' | translate}}</span>
    </div>
  </div>
  @if (!!form) {
    <form [formGroup]="form" class="ion-padding">
      <ion-item>
        <ion-input label="Username" labelPlacement="stacked" formControlName="username" (ionChange)="onUserNameChange()"></ion-input>
      </ion-item>
      <div class="ion-padding">
        @if ((isLoading$ | async) === true) {
          <div class="ion-text-center">
            <ion-spinner name="dots"></ion-spinner>
          </div>
        }
        @if ((isUserNameValid$ | async) === true) {
          <div class="ion-text-center form-error-message">
            <span>{{'CRUD_PROFILE_LIB.USERNAME_ALREADY_EXIST' | translate}}</span>
          </div>
        }
      </div>
    </form>
  }

</ion-content>
<ion-footer no-border>
  <ion-toolbar class="toolbar-footer">
    <ion-button class="custom-button" fill="outline" [disabled]="(isUserNameValid$ | async) === true || form.invalid" expand="block" routerLink="" color="primary"
      (click)="gotNextPage()" (keypress)="gotNextPage()">
      <span>{{'CRUD_PROFILE_LIB.NEXT' | translate}}</span>
      <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-footer>
